import { Injectable } from '@angular/core';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { DetectDeviceService } from '../../../common/user-agent.helpers';

@Injectable({ providedIn: 'root' })
export class TableTooltipConfig extends NgbTooltipConfig {
  public override disableTooltip = DetectDeviceService.isTouchDevice();
}
